import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Checkbox,
  Image,
  Input,
  Select
} from '@chakra-ui/react';
import ModalComponent from '@/common/Modal';
import { useEffect, useState } from 'react';
import { EditValuesToBeSavedInterface } from '@/model/editDetails.mjs';
import {
  getBusinessDetailsEdited,
  getContactDetailsEdit,
  getCustomAddressEdit,
  getContactDetailsError,
  getDealerActionsToBeSaved,
  getEmailErrorState,
  getIsCreateDealerActionCompleted,
  getIsCreateDealerActionInprogress,
  getNewContactDetailsError
} from '@/explore/ducks/selectors';
import { useDispatch } from 'react-redux';
import {
  callToCreateDealerAction,
  setBusinessDetailsEdited,
  setContactDetailsEdit,
  setContactDetailsError,
  setCustomAddressEdit,
  setDealerActionsToBeSaved,
  setIsCreateDealerActionCompleted,
  setNewContactDetailsError
} from '@/explore/ducks/slice';
import {
  contactSchema,
  emailSchema,
  getTextFeildSchema,
  phoneNumberSchema,
  websiteSchema
} from '@/model/yupSchema.mjs';
import { getProtocol } from '@/utils/urlProtocol.mjs';
import {
  ADD_THIS_EMAIL_ANYWAY,
  businessPhoneLabels,
  phoneLabels
} from '@/utils/constants';
import CustomRadio from '@/common/CustomRadio';
import {
  BusinessDetailsEditProps,
  ContactDetail,
  CustomAddress
} from '@/explore/types';
import ControlledInput from '@/common/ControllerInput';
import { formattedValues } from '@/model/contact-info.mjs';
import ContactDetailsEdit from './components/ContactDetailsEdit';
import './style.scss';
import { ErrorInterface } from '@/model/licenseHistory.mjs';
import AriaSelectDropdown from '@/common/AriaSelectDropdown';
import { transformContactDetails } from '../utils.mjs';
import CustomAddresses from './components/CustomAddressesEdit';
import { customAddressValidation } from '@/queue/ducks/validationSchema';
import { SHIPPING_ADDRESS_TYPE } from '@/model/licensee.mjs';
import { keyType } from '@/queue/types';

function BusinessDetailsEdit({
  onClose,
  isOpen,
  contactNames,
  licenseKey,
  phoneNumbers,
  emails,
  websites,
  primaryEmail,
  primaryPhone,
  contactDetailsList,
  customeAddressList,
  defaultShippingAddressCurrent,
  licenseDetails
}: BusinessDetailsEditProps) {
  const [addContactNameFields, setAddContactNameFields] = useState<
    Array<{ id: string; isPrimary: boolean; contact: string; error?: string }>
  >([]);
  const [addPhoneFields, setAddPhoneFields] = useState<
    Array<{
      id: string;
      isPrimary: boolean;
      phone: string;
      error?: string;
      label: string;
    }>
  >([]);
  const [addEmailFields, setAddEmailFields] = useState<
    Array<{
      id: string;
      isPrimary: boolean;
      email: string;
      error?: string;
      allowAsValidEmail?: boolean;
      allowAsValidEmailVisible?: boolean;
    }>
  >([]);
  const [addWebsitesFields, setAddWebsitesFields] = useState<
    Array<{ id: string; web_url: string; error?: string }>
  >([]);
  const [contactNameList, setcontactNameList] = useState<Array<string>>(
    contactNames || []
  );
  const [phoneList, setPhoneList] = useState<Array<formattedValues>>(
    phoneNumbers || []
  );

  const [emailList, setEmailList] = useState<Array<formattedValues>>(
    emails || []
  );

  const [websiteList, setWebsiteList] = useState<Array<string>>(websites || []);

  const [contactDetails, setContactDetails] =
    useState<Array<ContactDetail>>(contactDetailsList);

  const [customeAddress, setCustomeAddress] =
    useState<Array<CustomAddress>>(customeAddressList);

  const [contactDetailsForUpdate, setContactDetailsForUpdate] = useState<
    Array<ContactDetail>
  >([]);

  const [customAddressForUpdate, setCustomAddressForUpdate] = useState<
    Array<CustomAddress>
  >([]);

  const [addcontactDetails, setAddContactDetails] = useState<
    Array<ContactDetail>
  >([]);
  const [addCustomAddress, setAddCustomAddress] = useState<
    Array<CustomAddress>
  >([]);

  const [removeContactDetailIds, setRemoveContactDetailIds] = useState<
    Array<number>
  >([]);

  const [shippingAddressOptions, setShippingAddressOptions] = useState<{}>({});
  const [shippingAddressSelecValue, setShippingAddressSelecValue] =
    useState<string>('');
  const [defaultShippingAddress, setDefaultShippingAddress] =
    useState<string>('');

  const [removeCustomAddressIds, setRemoveCustomAddressIds] = useState<
    Array<number>
  >([]);

  const [isSaveAllowed, setIsSaveAllowed] = useState(false);

  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const businessDetailsEdited = getBusinessDetailsEdited();
  const emailErrorState = getEmailErrorState();
  const newContactDetailsError = getNewContactDetailsError();
  const contactDetailsError = getContactDetailsError();
  const contactDetailsEdit = getContactDetailsEdit();
  const customAddressEdit = getCustomAddressEdit();
  const dispatch = useDispatch();

  useEffect(() => {
    let newEmailListWithError: any = [];
    for (const emailState of emailErrorState) {
      const emailIndex = addEmailFields.findIndex(
        (eState) => eState.email === emailState.fieldValue
      );
      if (
        addEmailFields.length &&
        emailIndex >= 0 &&
        emailState.reason == 'verification_failed'
      ) {
        addEmailFields[emailIndex].error = 'Enter a valid email id';
        addEmailFields[emailIndex].allowAsValidEmailVisible = true;
        addEmailFields[emailIndex].allowAsValidEmail = false;
      }
    }
    newEmailListWithError = JSON.parse(JSON.stringify(addEmailFields));
    setAddEmailFields(newEmailListWithError);
  }, [emailErrorState]);

  useEffect(() => {
    if (newContactDetailsError && newContactDetailsError.length > 0) {
      updateContactDetailsError(newContactDetailsError, true);
    }
    if (contactDetailsError && contactDetailsError.length > 0) {
      updateContactDetailsError(contactDetailsError);
    }
  }, [newContactDetailsError, contactDetailsError]);

  const updateContactDetailsError = (
    contactDetailsErrorList: Array<ErrorInterface>,
    isNew = false
  ) => {
    let contactDetailsToupdate = isNew
      ? [...addcontactDetails]
      : [...contactDetails];
    const updateCOntactDetailsList = isNew
      ? setAddContactDetails
      : setContactDetails;
    for (const contactDetailsErrorItem of contactDetailsErrorList) {
      const { errorField, reason, fieldValue } = contactDetailsErrorItem;
      console.log('contactDetailsErrorItem', contactDetailsErrorItem);
      contactDetailsToupdate = contactDetailsToupdate.map((contactDetail) => {
        if (
          contactDetail[errorField] === fieldValue &&
          reason === 'verification_failed'
        ) {
          return {
            ...contactDetail,
            errors: {
              ...(contactDetail?.errors || {}),
              [errorField]:
                errorField === 'email' ? 'Enter a valid email id' : ''
            },
            allowAsValidEmail: false,
            allowAsValidEmailVisible: true
          };
        }
        return contactDetail;
      });
    }
    updateCOntactDetailsList(contactDetailsToupdate);
  };

  useEffect(() => {
    return () => {
      dispatch(setDealerActionsToBeSaved([]));
      dispatch(setNewContactDetailsError([]));
      dispatch(setContactDetailsError([]));
    };
  }, []);

  useEffect(() => {
    if (isCreateDealerActionCompleted) {
      const newEditedContactDetails =
        contactDetailsEdit && addcontactDetails && addcontactDetails.length > 0
          ? contactDetailsEdit
          : [];
      const updatedContactDetails = [
        ...contactDetails,
        ...newEditedContactDetails
      ].map((contactDetail) => {
        const { allowAsValidEmail, allowAsValidEmailVisible, ...restDetail } =
          contactDetail;
        return restDetail;
      });
      dispatch(
        setContactDetailsEdit(transformContactDetails(updatedContactDetails))
      );
      dispatch(
        setCustomAddressEdit([
          ...customeAddress,
          ...(customAddressEdit &&
          addCustomAddress &&
          addCustomAddress.length > 0
            ? customAddressEdit
            : [])
        ])
      );
      const editedEmails = addEmailFields
        .map((item) => ({ ...item, value: item.email }))
        .filter((item) => item.value && !item.error);
      const updatedEmails = new Set([...emailList, ...editedEmails]);

      const editedPhones = addPhoneFields
        .map((item) => ({ ...item, value: item.phone }))
        .filter((item) => item.value && !item.error);
      const updatedPhones = new Set([...phoneList, ...editedPhones]);
      const editedWebsites = addWebsitesFields
        .map((item) => item.web_url)
        .filter((item) => item);
      const updatedWebsites = new Set([...websiteList, ...editedWebsites]);
      const editedContacts = addContactNameFields
        .map((item) => item.contact)
        .filter((item) => item);
      const updatedContacts = new Set([...contactNameList, ...editedContacts]);
      dispatch(
        setBusinessDetailsEdited({
          ...businessDetailsEdited,
          emails: [...updatedEmails],
          phones: [...updatedPhones],
          websites: [...updatedWebsites],
          contacts: [...updatedContacts]
        })
      );
     
      dispatch(setIsCreateDealerActionCompleted(false));
      onClose();
    }
  }, [isCreateDealerActionCompleted]);

  const onClickAddPhone = () => {
    const numberOfPhones =
      addPhoneFields.length + (phoneList ? phoneList?.length : 0);
    if (numberOfPhones < 4) {
      const id = getNewFieldId(addPhoneFields, 'phone-field');
      setAddPhoneFields([
        ...addPhoneFields,
        {
          id,
          isPrimary: numberOfPhones > 0 ? false : true,
          phone: '',
          label: 'phone_label_work'
        }
      ]);
    }
  };

  const onClickAddEmail = () => {
    const numberOfEmails =
      addEmailFields.length + (emailList ? emailList?.length : 0);
    if (numberOfEmails < 3) {
      const id = getNewFieldId(addEmailFields, 'email-field');
      setAddEmailFields([
        ...addEmailFields,
        {
          id,
          isPrimary: numberOfEmails > 0 ? false : true,
          email: ''
        }
      ]);
    }
  };

  const onClickAddWebsite = () => {
    const numberOfWebsites =
      addWebsitesFields.length + (websiteList ? websiteList?.length : 0);
    if (numberOfWebsites < 5) {
      const id = getNewFieldId(addWebsitesFields, 'web-url-field');
      setAddWebsitesFields([
        ...addWebsitesFields,
        {
          id,
          web_url: ''
        }
      ]);
    }
  };

  const getNewFieldId = (
    newFields: Array<{ id: string; isPrimary?: boolean; error?: string }>,
    idPrefix: string
  ) => {
    let id = `${idPrefix}-${newFields.length + 1}`;
    if (newFields.length > 0) {
      const splitIdElements = newFields[newFields.length - 1].id.split('-');
      const idNumber = Number(splitIdElements[splitIdElements.length - 1]);
      id = `${idPrefix}-${idNumber + 1}`;
    }
    return id;
  };

  async function isEmailDuplicate(emailToCheck: string): Promise<boolean> {
    const isExistEmail = emailList.findIndex(
      (emItem) => emItem.value === emailToCheck
    );
    if (isExistEmail >= 0) {
      return true;
    }
    const isExistAddEmail = addEmailFields.findIndex(
      (adEmItem) => adEmItem.email === emailToCheck
    );
    if (isExistAddEmail >= 0) {
      return true;
    }
    return false;
  }

  const validateCustomAddress = async (name: string, value: string) => {
    try {
      await customAddressValidation.validateAt(name, { [name]: value });
      return '';
    } catch (error: any) {
      return error.errors && error.errors.length > 0 ? error.errors[0] : '';
    }
  };

  async function validation(
    value: string,
    feildName: string,
    isContactDetails = false
  ) {
    const schemaObject: any = {
      email: emailSchema,
      is_primary_email: emailSchema,
      phone: phoneNumberSchema,
      web_url: websiteSchema,
      contact: contactSchema,
      name: getTextFeildSchema('name'),
      title: getTextFeildSchema('title'),
      label: getTextFeildSchema('label')
    };
    try {
      if (!isContactDetails && feildName === 'email') {
        const isDuplicate = await isEmailDuplicate(value);
        if (isDuplicate) {
          return 'Email is already in use';
        }
      }
      const res = await schemaObject[feildName].validate({
        [feildName]:
          feildName === 'website'
            ? `${!getProtocol(value) ? 'https://' : ''}${value}`
            : value
      });
      return '';
    } catch (error: any) {
      console.log(error);
      return error.errors && error.errors.length > 0 ? error.errors[0] : '';
    }
  }

  const onChangeContactName = async (
    id: string,
    value: string | boolean,
    fieldName: string,
    allowAsValidEmail?: string
  ) => {
    let error = allowAsValidEmail
      ? null
      : await validation(value as string, fieldName);
    const itemList = {
      contact: addContactNameFields,
      phone: addPhoneFields,
      email: addEmailFields,
      web_url: addWebsitesFields
    };
    type itemListKeyType = keyof typeof itemList;
    const updatedList = itemList[fieldName as itemListKeyType].map((name) => {
      if (name.id === id) {
        updateContactNameToDealerActions({
          name: fieldName,
          type: 'add',
          value: error ? '' : value,
          license_key: licenseKey,
          id,
          error: allowAsValidEmail ? null : error,
          ...(fieldName === 'email' && allowAsValidEmail
            ? { allowAsValidEmail: allowAsValidEmail === "checked", }
            : { allowAsValidEmail: allowAsValidEmail === "checked", allowAsValidEmailVisible: false })
        });
        return {
          ...name,
          [fieldName]: value,
          error: allowAsValidEmail ? null : error,
          ...(fieldName === 'email' && allowAsValidEmail
            ? { allowAsValidEmail: allowAsValidEmail === "checked", }
            : { allowAsValidEmail: allowAsValidEmail === "checked", allowAsValidEmailVisible: false })
        };
      }
      return name;
    });
    if (fieldName === 'contact')
      setAddContactNameFields(updatedList as unknown as any);
    if (fieldName === 'phone') setAddPhoneFields(updatedList as unknown as any);
    if (fieldName === 'email') setAddEmailFields(updatedList as unknown as any);
    if (fieldName === 'web_url')
      setAddWebsitesFields(updatedList as unknown as any);
  };

  const onDeleteHandler = (
    id: number,
    value: string | boolean,
    fieldName: string,
    isPrimary: Boolean = false
  ) => {
    if (isPrimary) return;
    updateContactNameToDealerActions({
      name: fieldName,
      type: 'remove',
      value,
      license_key: licenseKey,
      id: `${fieldName}-${id}`
    });
    if (fieldName === 'contact') {
      const contactNames = contactNameList.filter(
        (name, index) => index !== id
      );
      setcontactNameList(contactNames);
    }
    if (fieldName === 'phone') {
      const phones = phoneList.filter((name, index) => index !== id);
      setPhoneList(phones);
    }
    if (fieldName === 'email') {
      const newEmailList = emailList.filter((name, index) => index !== id);
      setEmailList(newEmailList);
    }

    if (fieldName === 'web_url') {
      const newWebsiteList = websiteList.filter((name, index) => index !== id);
      setWebsiteList(newWebsiteList);
    }
  };

  const onDeleteHandlerForNewFields = (
    id: string,
    fieldName: string,
    isPrimary = false
  ) => {
    if (isPrimary) return;
    if (addContactNameFields && fieldName === 'contact') {
      const newList = addContactNameFields.filter(
        (contact) => contact.id != id
      );
      setAddContactNameFields(newList);
    }
    if (addPhoneFields && fieldName === 'phone') {
      const newList = addPhoneFields.filter((item) => item.id != id);
      setAddPhoneFields(newList);
    }

    if (addEmailFields && fieldName === 'email') {
      const newList = addEmailFields.filter((item) => item.id != id);
      setAddEmailFields(newList);
    }

    if (addWebsitesFields && fieldName === 'web_url') {
      const newList = addWebsitesFields.filter((item) => item.id != id);
      setAddWebsitesFields(newList);
    }

    if (dealerActionsToBeSaved) {
      const actions = dealerActionsToBeSaved.filter(
        (action) => action.id != id
      );
      dispatch(setDealerActionsToBeSaved(actions));
    }
  };

  const updateContactNameToDealerActions = (
    editParams: EditValuesToBeSavedInterface
  ) => {
    let isAlreadyExist = false;
    const actions = dealerActionsToBeSaved
      .map((action) => {
        if (
          action?.id === editParams?.id &&
          action.name === editParams.name &&
          editParams.type != 'remove'
        ) {
          isAlreadyExist = true;
          return editParams;
        }
        return action;
      })
      .filter((item) => item.value);
    if (isAlreadyExist) dispatch(setDealerActionsToBeSaved(actions));
    else if (!editParams.error && editParams.value) {
      dispatch(
        setDealerActionsToBeSaved([...dealerActionsToBeSaved, editParams])
      );
    }
  };

  const onSaveHandler = () => {
    let addPrimaryPhoneValue: string | null = null;
    let dealerActions = dealerActionsToBeSaved;
    let defaultShippingAddressPayload;
    const labelsDealerAction = addPhoneFields.map((phoneField, index) => {
      if (phoneField.isPrimary) addPrimaryPhoneValue = phoneField.phone;
      return {
        name: phoneField.label,
        value: phoneField.phone,
        type: 'add',
        license_key: licenseKey
      };
    });
    if (addPrimaryPhoneValue) {
      dealerActions = dealerActionsToBeSaved.find(
        (dealerAction) => dealerAction.name === 'is_primary_phone'
      )
        ? dealerActionsToBeSaved.map((dealerAction) => {
            if (
              dealerAction.name === 'is_primary_phone' &&
              dealerAction.type === 'add' &&
              dealerAction.value === addPrimaryPhoneValue
            ) {
              return { ...dealerAction, value: addPrimaryPhoneValue };
            }
            return dealerAction;
          })
        : [
            ...dealerActions,
            {
              name: 'is_primary_phone',
              value: addPrimaryPhoneValue,
              type: 'add',
              license_key: licenseKey
            }
          ];
    }

    if (defaultShippingAddress !== shippingAddressSelecValue) {
      if (
        shippingAddressSelecValue === SHIPPING_ADDRESS_TYPE.MAILING ||
        shippingAddressSelecValue === SHIPPING_ADDRESS_TYPE.PREMISE
      ) {
        defaultShippingAddressPayload = { type: shippingAddressSelecValue };
      } else if (shippingAddressSelecValue.includes('CUSTOM')) {
        const shippingAddressSelecValueSplit =
          shippingAddressSelecValue.split('_');
        defaultShippingAddressPayload = {
          type: shippingAddressSelecValueSplit[0],
          id: shippingAddressSelecValueSplit[1]
        };
      }
    }

    dispatch(
      callToCreateDealerAction({
        actionList: [...dealerActions, ...labelsDealerAction],
        addContactDetailsPayload:
          addcontactDetails.length > 0
            ? { data: addcontactDetails, licenseKey }
            : undefined,
        addCustomAddressPayload:
          addCustomAddress.length > 0
            ? { data: addCustomAddress, licenseKey }
            : undefined,
        removeContactDetailsIds: removeContactDetailIds,
        removeCustomAddressIds: removeCustomAddressIds,
        updateContactDetails: contactDetailsForUpdate,
        updateCustomAddress: customAddressForUpdate,
        defaultShippingAddress: defaultShippingAddressPayload,
        licenseKey
      })
    );
  };

  const onChangePhonePrimary = async (
    event: any,
    index: any,
    data: formattedValues,
    isEditedField = false
  ) => {
    if (isEditedField) {
      const updatePhonePrimary = addPhoneFields.map((phone, ind) => {
        if (index === ind && event.target.checked)
          return { ...phone, isPrimary: true };
        return { ...phone, isPrimary: false };
      });
      setAddPhoneFields(updatePhonePrimary);
      if (event.target.checked) {
        const updateList = phoneList.map((phone, ind) => ({
          ...phone,
          isPrimary: false
        }));
        setPhoneList(updateList);
      }
    } else {
      const updatePhonePrimary = phoneList.map((phone, ind) => {
        if (index === ind && event.target.checked)
          return { ...phone, isPrimary: true };
        return { ...phone, isPrimary: false };
      });
      setPhoneList(updatePhonePrimary);
      if (event.target.checked) {
        const updateList = addPhoneFields.map((phone, ind) => ({
          ...phone,
          isPrimary: false
        }));
        setAddPhoneFields(updateList);
      }
    }
    const error = await validation(data.value as string, 'phone');
    updateContactNameToDealerActions({
      name: 'is_primary_phone',
      value: error || primaryPhone === data.value ? '' : data.value,
      type: 'add',
      license_key: licenseKey,
      id: `edit-primary-phone`
    });
  };

  const onChangePhoneField = async (
    value: string,
    index: any,
    data: formattedValues,
    feildName: string,
    isEditedField = false
  ) => {
    if (isEditedField) {
      const updatePhonePrimary = addPhoneFields.map((phone, ind) => {
        if (index === ind && value) return { ...phone, [feildName]: value };
        return phone;
      });
      setAddPhoneFields(updatePhonePrimary);
    } else {
      const updatePhonePrimary = phoneList.map((phone, ind) => {
        if (index === ind && value) return { ...phone, [feildName]: value };
        return phone;
      });
      setPhoneList(updatePhonePrimary);
    }
    if (!isEditedField && Object.keys(businessPhoneLabels).includes(feildName))
      return;
    const error = await validation(data.value as string, 'phone');
    updateContactNameToDealerActions({
      name: value,
      value: error ? '' : data.value,
      type: 'add',
      license_key: licenseKey,
      id: `edit-primary-phone`
    });
  };

  const onChangeEmailPrimary = async (
    event: any,
    index: any,
    data: formattedValues,
    isEditedField = false
  ) => {
    if (isEditedField) {
      const updateEmailPrimary = addEmailFields.map((email, ind) => {
        if (index === ind && event.target.checked)
          return { ...email, isPrimary: true };
        return { ...email, isPrimary: false };
      });
      setAddEmailFields(updateEmailPrimary);
      if (event.target.checked) {
        const updateList = emailList.map((email, ind) => ({
          ...email,
          isPrimary: false
        }));
        setEmailList(updateList);
      }
    } else {
      const updateEmailPrimary = emailList.map((email, ind) => {
        if (index === ind && event.target.checked)
          return { ...email, isPrimary: true };
        return { ...email, isPrimary: false };
      });
      setEmailList(updateEmailPrimary);
      if (event.target.checked) {
        const updateList = addEmailFields.map((email, ind) => ({
          ...email,
          isPrimary: false
        }));
        setAddEmailFields(updateList);
      }
    }
    const error = await validation(data.value as string, 'is_primary_email');
    updateContactNameToDealerActions({
      name: 'is_primary_email',
      value: error || primaryEmail === data.value ? '' : data.value,
      type: 'add',
      license_key: licenseKey,
      id: `edit-primary-email`
    });
  };

  const onClickAddContactDetails = () => {
    const numberOfContactDetails =
      addcontactDetails.length + contactDetails.length;
    if (numberOfContactDetails < 3)
      setAddContactDetails([
        ...addcontactDetails,
        {
          name: '',
          email: '',
          phone: [{ value: '', label: 'work' }],
          title: '',
          isPrimary: numberOfContactDetails === 0,
          allowAsValidEmail: true
        }
      ]);
  };

  const onClickAddCustomAddress = () => {
    const numberOfCustomAddress =
      addCustomAddress.length + customeAddress.length;
    if (numberOfCustomAddress < 3)
      setAddCustomAddress([
        ...addCustomAddress,
        {
          city: '',
          state: '',
          street: '',
          zipcode: ''
        }
      ]);
  };

  const onClickRemoveContactDetailsNewField = (contactDetailIndex: number) => {
    const newList = addcontactDetails.filter(
      (contactDetail, index) => contactDetailIndex != index
    );
    setAddContactDetails(newList);
  };

  const onClickRemoveCustomAddressNewField = (customAddressIndex: number) => {
    const newList = addCustomAddress.filter(
      (_, index) => customAddressIndex != index
    );
    setAddCustomAddress(newList);
  };

  const onClickRemoveContactDetail = (contactDetailId: number) => {
    const newList = contactDetails.filter(
      (contactDetail, index) => contactDetail?.id != contactDetailId
    );
    const newContactDetailsForUpdate = contactDetailsForUpdate.filter(
      (contactDetail, index) => contactDetail?.id != contactDetailId
    );
    setContactDetailsForUpdate(newContactDetailsForUpdate);
    setContactDetails(newList);
    setRemoveContactDetailIds((prevValue) => [...prevValue, contactDetailId]);
  };

  const onClickRemoveCustomAddress = (customAddressId: number) => {
    const newList = customeAddress.filter(
      (customAddress, _) => customAddress?.id != customAddressId
    );
    const newCustomAddressForUpdate = customAddressForUpdate.filter(
      (customAddress, _) => customAddress?.id != customAddressId
    );
    setCustomAddressForUpdate(newCustomAddressForUpdate);
    setCustomeAddress(newList);
    setRemoveCustomAddressIds((prevValue) => [...prevValue, customAddressId]);
  };

  const onChangeContactDetailField = async (
    value: string | number | boolean,
    fieldName: string,
    contactDetailIndex: number,
    isNew = false
  ) => {
    const setUpdatedList = isNew ? setAddContactDetails : setContactDetails;
    let error =
      fieldName === 'isPrimary'
        ? null
        : await validation(value as string, fieldName, true);
    setUpdatedList((prevValue) => {
      const updatedContactDetails = prevValue.map((contactDetail, index) => {
        const { errors } = contactDetail;
        if (index === contactDetailIndex) {
          const contactDetailToUpdate = {
            ...contactDetail,
            ...(fieldName === 'email' && {}),
            errors: {
              ...(errors || {}),
              [fieldName === 'allowAsValidEmail' ? 'email' : fieldName]: error
            },
            [fieldName]: value,
            ...(fieldName === 'email' ? { allowAsValidEmailVisible: false, allowAsValidEmail: false } : {})
          };
          if (!isNew) updateContactDetailsListForUpdate(contactDetailToUpdate);
          return contactDetailToUpdate;
        }
        return contactDetail;
      });
      return updatedContactDetails;
    });
  };

  const onChangeCustomAddressField = async (
    value: string,
    fieldName: string,
    customAddressIndex: number,
    isNew = false
  ) => {
    if (fieldName === 'zipcode' && value) {
      const isNumberImput = /^[0-9\b]+$/;
      if (!isNumberImput.test(value) || value.length > 5) {
        return;
      }
    }
    const setUpdatedList = isNew ? setAddCustomAddress : setCustomeAddress;
    let error = await validateCustomAddress(fieldName, value as string);
    setUpdatedList((prevValue) => {
      const updatedCustomAddress = prevValue.map((customAdd, index) => {
        const { errors } = customAdd;
        if (index === customAddressIndex) {
          const customAddressToUpdate = {
            ...customAdd,
            [fieldName]: value,
            errors: { ...(errors || {}), [fieldName]: error }
          };
          if (!isNew) updateCustomAddressListForUpdate(customAddressToUpdate);
          return customAddressToUpdate;
        }
        return customAdd;
      });
      return updatedCustomAddress;
    });
  };

  const onChangeContactDetailPhoneField = async (
    value: string,
    contactDetailIndex: number,
    phoneIndex: number,
    feildName: string,
    isNew = false
  ) => {
    if (
      feildName === 'value' &&
      (value.length > 10 ||
        value
          .split('')
          .map((item) => item.toLowerCase())
          .includes('e'))
    )
      return;
    const listForUpdate = isNew ? addcontactDetails : contactDetails;
    let error = value
      ? await validation(
          value as string,
          feildName === 'value' ? 'phone' : 'label',
          true
        )
      : null;
    let contactDetailToUpdate;
    const setUpdatedList = isNew ? setAddContactDetails : setContactDetails;
    const updatedContactDetails = listForUpdate.map((contactDetail, index) => {
      if (index === contactDetailIndex) {
        let { phone, errors } = contactDetail;
        errors = errors ? JSON.parse(JSON.stringify(errors)) : {};
        let updatedPhoneErrors: Array<{
          labelError: string;
          valueError: string;
        }> = [];
        if (errors?.phone) {
          if (!errors.phone[phoneIndex]) {
            errors.phone[phoneIndex] = {
              valueError: feildName === 'value' ? error : '',
              labelError: feildName === 'label' ? error : ''
            };
            updatedPhoneErrors = errors.phone;
          } else {
            updatedPhoneErrors = errors.phone.map(
              (phoneError, phoneErrorIndex) => {
                if (phoneIndex === phoneErrorIndex)
                  return {
                    ...phoneError,
                    [feildName === 'value' ? 'valueError' : 'labelError']: error
                  };
                return phoneError;
              }
            );
          }
        } else {
          updatedPhoneErrors = [
            {
              valueError: feildName === 'value' ? error : '',
              labelError: feildName === 'label' ? error : ''
            }
          ];
        }
        const updatedPhoneList = phone.map((phoneItem, index) => {
          if (index === phoneIndex) return { ...phoneItem, [feildName]: value };
          return phoneItem;
        });
        contactDetailToUpdate = {
          ...contactDetail,
          phone: updatedPhoneList,
          errors: { ...(errors || {}), phone: updatedPhoneErrors }
        };
        return contactDetailToUpdate;
      }
      return contactDetail;
    });
    setUpdatedList(updatedContactDetails);
    if (!isNew) updateContactDetailsListForUpdate(contactDetailToUpdate);
  };

  const updateContactDetailsListForUpdate = (contactDetail?: ContactDetail) => {
    if (!contactDetail || !contactDetail?.id) return;
    const originalValue = contactDetailsList.find(
      (contactDetailItem) => contactDetailItem?.id === contactDetail?.id
    );
    if (originalValue) {
      setContactDetailsForUpdate((prevContactDetailsForUpdate) => {
        if (JSON.stringify(contactDetail) !== JSON.stringify(originalValue)) {
          let isUpdated = false;
          const updatedList = prevContactDetailsForUpdate.map(
            (contactDetailItem, index) => {
              if (contactDetailItem?.id === contactDetail?.id) {
                isUpdated = true;
                return contactDetail;
              }
              return contactDetailItem;
            }
          );
          if (isUpdated) return updatedList;
          else return [...prevContactDetailsForUpdate, contactDetail];
        } else {
          const updatedList = contactDetailsForUpdate.filter(
            (contactDetailItem) => contactDetailItem?.id !== contactDetail?.id
          );
          return updatedList;
        }
      });
    }
  };

  const updateCustomAddressListForUpdate = (customeAddress?: CustomAddress) => {
    if (!customeAddress || !customeAddress?.id) return;
    const originalValue = customeAddressList.find(
      (customAddressItem) => customAddressItem?.id === customeAddress?.id
    );
    if (originalValue) {
      setCustomAddressForUpdate((prevCustomAddressForUpdate) => {
        if (JSON.stringify(customeAddress) !== JSON.stringify(originalValue)) {
          let isUpdated = false;
          const updatedList = prevCustomAddressForUpdate.map(
            (customAddressItem, index) => {
              if (customAddressItem?.id === customeAddress?.id) {
                isUpdated = true;
                return customeAddress;
              }
              return customAddressItem;
            }
          );
          if (isUpdated) return updatedList;
          else return [...prevCustomAddressForUpdate, customeAddress];
        } else {
          const updatedList = customAddressForUpdate.filter(
            (customAddressItem) => customAddressItem?.id !== customeAddress?.id
          );
          return updatedList;
        }
      });
    }
  };

  const onClickAddPhoneNumber = (contactDetailIndex: number, isNew = false) => {
    const setUpdatedList = isNew ? setAddContactDetails : setContactDetails;
    const contactDetailList = isNew ? addcontactDetails : contactDetails;
    const updatedList = contactDetailList.map((contactDetail, index) => {
      contactDetail.phone = contactDetail?.phone || [] 
      if (contactDetailIndex === index && contactDetail?.phone.length < 3)
        return {
          ...contactDetail,
          phone: [...contactDetail.phone, { value: '', label: 'work' }]
        };
      return contactDetail;
    });
    setUpdatedList(updatedList);
  };

  const onClickRemovePhoneNumber = (
    contactDetailIndex: number,
    phoneIndex: number,
    isNew = false
  ) => {
    const setUpdatedList = isNew ? setAddContactDetails : setContactDetails;
    const contactDetailList = isNew ? addcontactDetails : contactDetails;
    let contactDetailToUpdate;
    const updatedList = contactDetailList.map((contactDetail, index) => {
      if (contactDetailIndex === index) {
        const updatedPhoneList = contactDetail.phone.filter(
          (phoneItem, phoneItemIndex) => phoneItemIndex != phoneIndex
        );
        contactDetailToUpdate = { ...contactDetail, phone: updatedPhoneList };
        return contactDetailToUpdate;
      }
      return contactDetail;
    });
    setUpdatedList(updatedList);
    if (!isNew) updateContactDetailsListForUpdate(contactDetailToUpdate);
  };

  const updateIsSaveAllowed = () => {
    let isAllowed = true;
    if (addcontactDetails.length <= 0 && contactDetailsForUpdate.length <= 0) {
      setIsSaveAllowed(isAllowed);
      return;
    }
    if (
      (addcontactDetails.length > 0 &&
        getIsNotSaveAllowed(addcontactDetails)) ||
      (contactDetailsForUpdate.length > 0 &&
        getIsNotSaveAllowed(contactDetailsForUpdate))
    ) {
      isAllowed = false;
    }
    setIsSaveAllowed(isAllowed);
  };

  const updateIsSaveAllowedCustomAddress = () => {
    let isAllowed = true;

    if (addCustomAddress.length <= 0 && customAddressForUpdate.length <= 0) {
      setIsSaveAllowed(isAllowed);
      return;
    }
    if (
      (addCustomAddress.length > 0 &&
        getIsNotSaveAllowedAddress(addCustomAddress)) ||
      (customAddressForUpdate.length > 0 &&
        getIsNotSaveAllowedAddress(customAddressForUpdate))
    ) {
      isAllowed = false;
    }

    setIsSaveAllowed(isAllowed);
  };

  const getIsNotSaveAllowed = (contactDetailsToCheck: Array<ContactDetail>) => {
    return contactDetailsToCheck.some((contactDetail) => {
      const { email, title, name, phone, errors } = contactDetail;
      if (
        (!email &&
          !title &&
          !name &&
          phone.every((phoneItem) => !phoneItem.value)) ||
        (errors && (errors?.title || errors?.email || errors?.name)) ||
        errors?.phone?.some(
          (phoneErrorItem) =>
            Boolean(phoneErrorItem.labelError) ||
            Boolean(phoneErrorItem.valueError)
        )
      ) {
        return true;
      }
      return false;
    });
  };

  const getIsNotSaveAllowedAddress = (
    customAddressToCheck: Array<CustomAddress>
  ) => {
    return customAddressToCheck.some((customAdd) => {
      const { errors, state, city, zipcode, street } = customAdd;
      if (
        (errors &&
          (errors?.state ||
            errors?.city ||
            errors?.zipcode ||
            errors?.street)) ||
        !state ||
        !city ||
        !zipcode ||
        !street
      ) {
        return true;
      }
      return false;
    });
  };

  useEffect(() => {
    updateIsSaveAllowed();
  }, [addcontactDetails, contactDetails, removeContactDetailIds]);

  useEffect(() => {
    updateIsSaveAllowedCustomAddress();
  }, [addCustomAddress, customeAddress, removeCustomAddressIds]);

  const getIsNotAllowedToSaveValue = () => {
    let isNotAllowed = true;
    if (defaultShippingAddress !== shippingAddressSelecValue)
      isNotAllowed = false;
    if (dealerActionsToBeSaved.length > 0) isNotAllowed = false;
    if (removeContactDetailIds.length > 0) {
      isNotAllowed = false;
    }
    if (
      (addcontactDetails.length > 0 || contactDetailsForUpdate.length > 0) &&
      isSaveAllowed
    )
      isNotAllowed = false;
    if (
      (addcontactDetails.length > 0 || contactDetailsForUpdate.length > 0) &&
      !isSaveAllowed
    )
      isNotAllowed = true;

    if (removeCustomAddressIds.length > 0) {
      isNotAllowed = false;
    }
    if (
      (addCustomAddress.length > 0 || customAddressForUpdate.length > 0) &&
      isSaveAllowed
    ) {
      isNotAllowed = false;
    }
    if (
      (addCustomAddress.length > 0 || customAddressForUpdate.length > 0) &&
      !isSaveAllowed
    ) {
      isNotAllowed = true;
    }
    return isNotAllowed;
  };

  useEffect(() => {
    const premiseAddress = licenseDetails.contact.address;
    if (premiseAddress) {
      setShippingAddressOptions((prevShippingAddressOptions) => ({
        ...prevShippingAddressOptions,
        ...{
          PREMISE: `${premiseAddress.street1}, ${
            premiseAddress.street2 ? `${premiseAddress.street2} , ` : ' '
          } ${premiseAddress.city}, ${premiseAddress.state}, ${
            premiseAddress.zip
          }`
        }
      }));
    }
    const mailAddress = licenseDetails.contact.mailAddress;
    if (mailAddress) {
      setShippingAddressOptions((prevShippingAddressOptions) => ({
        ...prevShippingAddressOptions,
        ...{
          MAILING: `${mailAddress.street}, ${mailAddress.city}, ${mailAddress.state}, ${mailAddress.zip}`
        }
      }));
    }
    customeAddress.map((address) => {
      setShippingAddressOptions((prevShippingAddressOptions) => ({
        ...prevShippingAddressOptions,
        ...{
          [`CUSTOM_${address.id}`]: `${address.street}, ${address.city}, ${address.state}, ${address.zipcode}`
        }
      }));
    });
    const defaultShippingAddressValue = getDefaultShippingAddress();
    setDefaultShippingAddress(defaultShippingAddressValue);
    setShippingAddressSelecValue(defaultShippingAddressValue);
  }, []);

  const onChangeDefaultShippingAddress = (arg: string) => {
    setShippingAddressSelecValue(arg);
  };

  const getDefaultShippingAddress = () => {
    let deafultAddress: string = SHIPPING_ADDRESS_TYPE.PREMISE;
    const deafultShippingAddress = defaultShippingAddressCurrent || {
      type: SHIPPING_ADDRESS_TYPE.PREMISE
    };
    let shippingType = deafultShippingAddress.type
      ? SHIPPING_ADDRESS_TYPE[
          deafultShippingAddress.type as keyType<typeof SHIPPING_ADDRESS_TYPE>
        ] || SHIPPING_ADDRESS_TYPE.PREMISE
      : SHIPPING_ADDRESS_TYPE.PREMISE;

    if (
      shippingType === SHIPPING_ADDRESS_TYPE.CUSTOM &&
      deafultShippingAddress?.id
    ) {
      if (customeAddress && customeAddress.length > 0) {
        customeAddress.some((customAddress) => {
          if (String(deafultShippingAddress?.id) === String(customAddress.id)) {
            deafultAddress = `CUSTOM_${customAddress.id}`;
            return true;
          }
        });
      }
    }
    if (shippingType === SHIPPING_ADDRESS_TYPE.MAILING) {
      deafultAddress = SHIPPING_ADDRESS_TYPE.MAILING;
    }
    return deafultAddress;
  };

  return (
    <ModalComponent
      onClose={onClose}
      isOpen={isOpen}
      title={<>Edit Business Details</>}
      variant={2}
      className="business-edit-modal"
      footer={
        <>
          <Button
            colorScheme="blue"
            onClick={onClose}
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            marginRight="20px"
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={onSaveHandler}
            isLoading={isCreateDealerActionInprogress}
            isDisabled={getIsNotAllowedToSaveValue()}
          >
            Save
          </Button>
        </>
      }
    >
      <Accordion allowToggle defaultIndex={[0]}>
        <AccordionItem className="license-accordian">
          {({ isExpanded }) => (
            <>
              <h2>
                <AccordionButton
                  background={'#0C1E46'}
                  className="license-accordian-btn edit"
                >
                  <Box as="span" flex="1" textAlign="left">
                    Business Phone Number
                  </Box>
                  {isExpanded ? (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon"
                    />
                  ) : (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon expanded"
                    />
                  )}
                </AccordionButton>
              </h2>
              <AccordionPanel padding={'15px 20px'}>
                <div className="license-edit">
                  <div className="license-edit__title">Phone Number:</div>
                  <div className="license-edit-right">
                    <ul className="license-edit__rows">
                      {phoneList &&
                        phoneList.map((phone, index) => (
                          <li className="license-edit__row" key={index}>
                            <div className="license-edit__row-inner">
                              <Input
                                className="license-edit__input license-edit__input-phone"
                                type="text"
                                placeholder="Enter Phone Number"
                                value={phone.value}
                                disabled
                              />
                              <div className="license-edit__select-wrapper">
                                {/* <Select
                                  placeholder="-Label-"
                                  className="license-edit__select"
                                >
                                  {Object.entries(phoneLabels).map(
                                    ([label], index) => (
                                      <option value={label} key={index}>
                                        {label}
                                      </option>
                                    )
                                  )}
                                </Select> */}
                                <AriaSelectDropdown
                                  onChangeDropdown={(value) =>
                                    onChangePhoneField(
                                      value as string,
                                      index,
                                      phone,
                                      'label'
                                    )
                                  }
                                  selectedOption={phone.label || ''}
                                  options={Object.entries(businessPhoneLabels)}
                                  className="react-aria-Select react-aria-select-light"
                                  variant="light"
                                  placeholder="-Label-"
                                />
                              </div>
                              <div className="license-edit__checkbox-wrapper">
                                <CustomRadio
                                  name={'primary_phone'}
                                  id={`edit-phone-label-${index}`}
                                  value="primary_phone"
                                  isChecked={phone.isPrimary as boolean}
                                  onChange={(e: any) =>
                                    onChangePhonePrimary(e, index, phone)
                                  }
                                />
                                <label
                                  className={`license-edit__checkbox-label active-label`}
                                  htmlFor={`edit-phone-label-${index}`}
                                >
                                  Primary
                                </label>
                              </div>
                              <Button
                                className="license-edit__delete"
                                onClick={() =>
                                  onDeleteHandler(
                                    index,
                                    phone.value,
                                    'phone',
                                    phone.isPrimary
                                  )
                                }
                                isDisabled={Boolean(phone.isPrimary)}
                              >
                                <Image src="/images/ui/delete.svg" />
                              </Button>
                            </div>
                          </li>
                        ))}
                      {addPhoneFields.map((item, index) => (
                        <li className="license-edit__row" key={index}>
                          <div className="license-edit__row-inner">
                            {' '}
                            <ControlledInput
                              className="license-edit__input license-edit__input-phone"
                              type="number"
                              placeholder="Enter Phone Number"
                              value={item.phone}
                              onChange={(event) =>
                                onChangeContactName(
                                  item.id,
                                  event.target.value,
                                  'phone'
                                )
                              }
                            />
                            <div className="license-edit__select-wrapper">
                              {/* <Select
                                placeholder="-Label-"
                                className="license-edit__select"
                              >
                                {Object.entries(phoneLabels).map(
                                  ([label], index) => (
                                    <option value={label} key={index}>
                                      {label}
                                    </option>
                                  )
                                )}
                              </Select> */}
                              <AriaSelectDropdown
                                onChangeDropdown={(value) =>
                                  onChangePhoneField(
                                    value as string,
                                    index,
                                    { ...item, value: item.phone },
                                    'label',
                                    true
                                  )
                                }
                                selectedOption={item.label || ''}
                                options={Object.entries(businessPhoneLabels)}
                                className="react-aria-Select react-aria-select-light"
                                variant="light"
                                placeholder="-Label-"
                              />
                            </div>
                            <div className="license-edit__checkbox-wrapper">
                              <CustomRadio
                                name={'primary_phone'}
                                id={`add-phone-label-${index}`}
                                value="primary_phone"
                                isChecked={item.isPrimary as boolean}
                                onChange={(e: any) =>
                                  onChangePhonePrimary(
                                    e,
                                    index,
                                    { ...item, value: item.phone },
                                    true
                                  )
                                }
                              />
                              <label
                                className="license-edit__checkbox-label active-label"
                                htmlFor={`add-phone-label-${index}`}
                              >
                                Primary
                              </label>
                            </div>
                            <Button
                              className="license-edit__delete"
                              onClick={() =>
                                onDeleteHandlerForNewFields(
                                  item.id,
                                  'phone',
                                  item.isPrimary
                                )
                              }
                              isDisabled={Boolean(item.isPrimary)}
                            >
                              <Image src="/images/ui/delete.svg" />
                            </Button>
                          </div>
                          {item.error && (
                            <div className="edit-error">* {item.error}</div>
                          )}
                        </li>
                      ))}
                    </ul>
                    <button
                      className="business-add-btn"
                      onClick={onClickAddPhone}
                      disabled={
                        addPhoneFields.length +
                          (phoneList ? phoneList?.length : 0) >=
                        4
                      }
                    >
                      + Add Phone Number
                    </button>
                  </div>
                </div>
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
        <AccordionItem className="license-accordian">
          {({ isExpanded }) => (
            <>
              <h2>
                <AccordionButton
                  background={'#0C1E46'}
                  className="license-accordian-btn edit"
                >
                  <Box as="span" flex="1" textAlign="left">
                    Business Email Address
                  </Box>
                  {isExpanded ? (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon"
                    />
                  ) : (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon expanded"
                    />
                  )}
                </AccordionButton>
              </h2>
              <AccordionPanel padding={'23px 20px'}>
                <div className="license-edit">
                  <div className="license-edit__title">Email Address:</div>
                  <div className="license-edit-right">
                    <ul className="license-edit__rows">
                      {emailList &&
                        emailList.map((email, index) => (
                          <li className="license-edit__row" key={index}>
                            <div className="license-edit__row-inner">
                              <ControlledInput
                                className="license-edit__input email"
                                type="email"
                                placeholder="Enter Email Address"
                                value={email.value}
                                disabled={true}
                              />
                              <div className="license-edit__checkbox-wrapper">
                                <CustomRadio
                                  name={'primary_email'}
                                  id={`add-email-label-${index}`}
                                  value="primary_phone"
                                  isChecked={email.isPrimary as boolean}
                                  onChange={(e: any) =>
                                    onChangeEmailPrimary(e, index, email)
                                  }
                                />
                                <label
                                  className="license-edit__checkbox-label active-label"
                                  htmlFor={`add-email-label-${index}`}
                                >
                                  Primary
                                </label>
                              </div>
                              <Button
                                className="license-edit__delete"
                                onClick={() =>
                                  onDeleteHandler(
                                    index,
                                    email.value,
                                    'email',
                                    email.isPrimary
                                  )
                                }
                                isDisabled={Boolean(email.isPrimary)}
                              >
                                <Image src="/images/ui/delete.svg" />
                              </Button>
                            </div>
                          </li>
                        ))}

                      {addEmailFields &&
                        addEmailFields.map((item, index) => (
                          <li className="license-edit__row" key={index}>
                            <div className="license-edit__row-inner">
                              <ControlledInput
                                className="license-edit__input email"
                                placeholder="Enter Email Address"
                                value={item.email}
                                onChange={(event) =>
                                  onChangeContactName(
                                    item.id,
                                    event.target.value,
                                    'email'
                                  )
                                }
                                type="text"
                              />
                              <div className="license-edit__checkbox-wrapper">
                                <CustomRadio
                                  name={'primary_email'}
                                  id={`add-email-label-${index}`}
                                  value="primary_email"
                                  isChecked={item.isPrimary as boolean}
                                  onChange={(e: any) =>
                                    onChangeEmailPrimary(
                                      e,
                                      index,
                                      { ...item, value: item.email },
                                      true
                                    )
                                  }
                                />
                                <label className="license-edit__checkbox-label active-label">
                                  Primary
                                </label>
                              </div>
                              <Button
                                className="license-edit__delete"
                                onClick={() =>
                                  onDeleteHandlerForNewFields(
                                    item.id,
                                    'email',
                                    item.isPrimary
                                  )
                                }
                                isDisabled={Boolean(item.isPrimary)}
                              >
                                <Image src="/images/ui/delete.svg" />
                              </Button>
                            </div>
                            {item.error && (
                              <div className="edit-error">* {item.error}</div>
                            )}
                            {item.allowAsValidEmailVisible && (
                              <Checkbox
                                className="edit-info"
                                isChecked={item.allowAsValidEmail}
                                onChange={(event) =>
                                  onChangeContactName(
                                    item.id,
                                    item.email,
                                    'email',
                                    item.allowAsValidEmail ? "unchecked" : "checked"
                                  )
                                }
                              >
                                {ADD_THIS_EMAIL_ANYWAY}
                              </Checkbox>
                            )}
                          </li>
                        ))}
                    </ul>
                    <button
                      className="business-add-btn"
                      onClick={onClickAddEmail}
                      disabled={
                        addEmailFields.length +
                          (emailList ? emailList?.length : 0) >=
                        3
                      }
                    >
                      + Add Email Address
                    </button>
                  </div>
                </div>
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
        <AccordionItem className="license-accordian">
          {({ isExpanded }) => (
            <>
              <h2>
                <AccordionButton
                  background={'#0C1E46'}
                  className="license-accordian-btn edit"
                >
                  <Box as="span" flex="1" textAlign="left">
                    Contact Detail
                  </Box>
                  {isExpanded ? (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon"
                    />
                  ) : (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon expanded"
                    />
                  )}
                </AccordionButton>
              </h2>
              <AccordionPanel padding={0}>
                <ContactDetailsEdit
                  onClickAddContactDetails={onClickAddContactDetails}
                  addcontactDetails={addcontactDetails}
                  contactDetails={contactDetails}
                  onChangeContactDetailField={onChangeContactDetailField}
                  onChangeContactDetailPhoneField={
                    onChangeContactDetailPhoneField
                  }
                  onClickRemoveContactDetailsNewField={
                    onClickRemoveContactDetailsNewField
                  }
                  onClickRemoveContactDetail={onClickRemoveContactDetail}
                  onClickAddPhoneNumber={onClickAddPhoneNumber}
                  onClickRemovePhoneNumber={onClickRemovePhoneNumber}
                />
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
        <AccordionItem className="license-accordian">
          {({ isExpanded }) => (
            <>
              <h2>
                <AccordionButton
                  background={'#0C1E46'}
                  className="license-accordian-btn edit"
                >
                  <Box as="span" flex="1" textAlign="left">
                    Physical Address
                  </Box>
                  {isExpanded ? (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon"
                    />
                  ) : (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon expanded"
                    />
                  )}
                </AccordionButton>
              </h2>
              <AccordionPanel padding={0}>
                <CustomAddresses
                  onClickAddCustomAddress={onClickAddCustomAddress}
                  addCustomAddress={addCustomAddress}
                  customeAddress={customeAddress}
                  onChangeCustomAddressField={onChangeCustomAddressField}
                  onClickRemoveCustomAddressNewField={
                    onClickRemoveCustomAddressNewField
                  }
                  onClickRemoveCustomAddress={onClickRemoveCustomAddress}
                  shippingAddressOptions={shippingAddressOptions}
                  onChangeDefaultShippingAddress={
                    onChangeDefaultShippingAddress
                  }
                  shippingAddressSelecValue={shippingAddressSelecValue}
                />
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
        <AccordionItem className="license-accordian">
          {({ isExpanded }) => (
            <>
              <h2>
                <AccordionButton
                  background={'#0C1E46'}
                  className="license-accordian-btn edit"
                >
                  <Box as="span" flex="1" textAlign="left">
                    Website URL
                  </Box>
                  {isExpanded ? (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon"
                    />
                  ) : (
                    <Image
                      src="/images/ui/arrow-white.svg"
                      className="accordian-icon expanded"
                    />
                  )}
                </AccordionButton>
              </h2>
              <AccordionPanel padding={'23px 20px'}>
                <div className="license-edit">
                  <div className="license-edit__title">Website URL:</div>
                  <div className="license-edit-right">
                    <ul className="license-edit__rows">
                      {websites &&
                        websiteList.map((website, index) => (
                          <li className="license-edit__row" key={index}>
                            <div className="license-edit__row-inner">
                              <Input
                                className="license-edit__input website"
                                type="text"
                                placeholder="Enter Website URL"
                                value={website}
                                disabled
                              />
                              <Button
                                className="license-edit__delete"
                                onClick={() =>
                                  onDeleteHandler(index, website, 'web_url')
                                }
                              >
                                <Image src="/images/ui/delete.svg" />
                              </Button>
                            </div>
                          </li>
                        ))}
                      {addWebsitesFields &&
                        addWebsitesFields.map((item, index) => (
                          <li className="license-edit__row" key={index}>
                            <div className="license-edit__row-inner">
                              <ControlledInput
                                className="license-edit__input website"
                                type="text"
                                placeholder="Enter Website URL"
                                value={item.web_url}
                                onChange={(event) =>
                                  onChangeContactName(
                                    item.id,
                                    event.target.value,
                                    'web_url'
                                  )
                                }
                              />
                              <Button
                                className="license-edit__delete"
                                onClick={() =>
                                  onDeleteHandlerForNewFields(
                                    item.id,
                                    'web_url'
                                  )
                                }
                              >
                                <Image src="/images/ui/delete.svg" />
                              </Button>
                            </div>
                            {item.error && (
                              <div className="edit-error">* {item.error}</div>
                            )}
                          </li>
                        ))}
                    </ul>
                    <button
                      className="business-add-btn"
                      onClick={onClickAddWebsite}
                      disabled={
                        addWebsitesFields.length +
                          (websiteList ? websiteList?.length : 0) >=
                        3
                      }
                    >
                      + Add Website
                    </button>
                  </div>
                </div>
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      </Accordion>
    </ModalComponent>
  );
}

export default BusinessDetailsEdit;
